/* istanbul ignore file */

/* Active templates on the Offer-Detail page */
import ChangeServiceForm_initial from "./ChangeServiceForm_initial";

export default {
  ChangeServiceForm_initial,
};
